module.exports = __webpack_public_path__ + "images/feature/pro-order-f311d254f18659b32ddbbe3f34a872c7.jpg";